// extracted by mini-css-extract-plugin
export default {"container":"Bl-z","title":"Cl-z","linkContainer":"Dl-z","viewItemLink":"El-z"};